module.exports = __webpack_public_path__ + "img/icon_bms1.3ed9bffa.jpg";